"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.content = void 0;
var env_1 = require("../../env");
exports.content = {
  id: 'content',
  label: 'Content',
  showInNavigation: false,
  scopes: env_1.USE_GRANULAR_SIDEBAR_SCOPES ? ['admin:any', 'read:menu:content'] : null,
  children: [{
    id: 'sites',
    type: 'list',
    entityTypeName: 'Site',
    scopes: env_1.USE_GRANULAR_SIDEBAR_SCOPES ? ['admin:any', 'read:menu:sites'] : null
  }, {
    id: 'pages',
    type: 'list',
    entityTypeName: 'Page',
    scopes: env_1.USE_GRANULAR_SIDEBAR_SCOPES ? ['admin:any', 'read:menu:pages'] : null
  }, {
    id: 'posts',
    type: 'list',
    entityTypeName: 'Post',
    scopes: env_1.USE_GRANULAR_SIDEBAR_SCOPES ? ['admin:any', 'read:menu:posts'] : null
  }, {
    id: 'podcasts',
    type: 'list',
    entityTypeName: 'Podcast',
    scopes: env_1.USE_GRANULAR_SIDEBAR_SCOPES ? ['admin:any', 'read:menu:podcasts'] : null
  }, {
    id: 'documents',
    type: 'list',
    entityTypeName: 'Document',
    scopes: env_1.USE_GRANULAR_SIDEBAR_SCOPES ? ['admin:any', 'read:menu:documents'] : null
  }]
};